const cancelledTaskIds = new Set();

export function isSmartCutoutTaskCancelled(taskId) {
  if (taskId == null) return false;
  return cancelledTaskIds.has(String(taskId));
}

export function cancelSmartCutoutTask(taskId) {
  if (taskId == null) return;
  cancelledTaskIds.add(String(taskId));
}

export function clearSmartCutoutTaskCancelled(taskId) {
  if (taskId == null) return;
  cancelledTaskIds.delete(String(taskId));
}
